/* eslint-disable no-undef */
// userSaga.js
import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST_TIME_SLOTS, UPDATE_SCHEDULE_SLOT } from './Constants';
import { timeSlotRequestError, timeSlotRequestSuccess, updateScheduleSlotRequestError, updateScheduleSlotRequestSuccess } from './Actions';
// import { Modal } from 'antd';


function* getTimeSlots(action) {

    try {

        let orgurl;
        let uh = false;

        const orgid = action.payload.orgid;

        orgurl = `${process.env.REACT_APP_API_BASE_URL}/orgpatients?patientsId=${action.payload.patientId}&organisationsId=${orgid}`; // eslint-disable-line


        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        // // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)


        const response1 = yield call(axios.get, orgurl, { headers });

        // // Check if the response is successful
        if (response1.status === 200 || response1.status === 201) {

            if (response1.data.total === 0) {

                uh = true;
            } else {
                uh = false;
            }

            console.log('uh', uh);

            // const tempDate = new Date();
            // const time = tempDate.getHours() + ':' + tempDate.getMinutes() + ':' + tempDate.getSeconds();
            let url;
            const doctorId = action.payload.doctorID;
            const startDate = action.payload.startDate;
            const endDate = action.payload.endDate;


            url = `${process.env.REACT_APP_API_BASE_URL}/schedules?doctorsId=${doctorId}&consultationTypeId[$in][]=3&consultationTypeId[$in][]=13&consultationTypeId[$in][]=14&date[$gte]=${startDate}&date[$lte]=${endDate}&$sort[date]=1&$sort[time]=1&$limit=1000`;

            const response2 = yield call(axios.get, url, { headers });

            if (response2.status === 200 || response2.status === 201) {
                if (response2.data.total > 0) {
                    yield put(timeSlotRequestSuccess(response2.data));
                }
            }


            // Dispatch the success action with data and message      
        } else {
            // Dispatch the failure action with the response message
            yield put(timeSlotRequestError('An error occurred.'));
        }

    } catch (error) {

        // yield put(passportRequestError('An error occurred.'));
        // throw error;
        // yield put(fetchUserFailure(error));
    }
}

function* updateConsultaionShedule(action) {

    try {

        const consulationId = action.payload.consultationTypeId;
        const orgFeeId = action.payload.orgFeesId;
        const slotId = action.payload.slotId;

        const url1 = `${process.env.REACT_APP_API_BASE_URL}/schedules/${slotId}`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        const data = {
            orgFeesId: orgFeeId,
            consultationTypeId: consulationId,
        };
        
        const response1 = yield call(axios.patch, url1, data, { headers });

        // // Check if the response is successful
        if (response1.status === 200 || response1.status === 201) {


            const url2 = `${process.env.REACT_APP_API_BASE_URL}/schedules?id=${response1.data.id}`;

            const response2 = yield call(axios.get, url2, { headers });

            if(response2.status === 200 || response2.status === 201) {
                yield put(updateScheduleSlotRequestSuccess(response2.data));
            }  
        } else {
            // Dispatch the failure action with the response message
            yield put(updateScheduleSlotRequestError('An error occurred.'));
        }

    } catch (error) {

        // yield put(passportRequestError('An error occurred.'));
        // throw error;
        // yield put(fetchUserFailure(error));
    }
}


// Watcher Saga
export function* watchFetchTimeSlot() {
    yield takeEvery(REQUEST_TIME_SLOTS, getTimeSlots);
    yield takeEvery(UPDATE_SCHEDULE_SLOT, updateConsultaionShedule);

}
